import { render } from "./TasksManager.vue?vue&type=template&id=4946cbbc"
import script from "./TasksManager.vue?vue&type=script&lang=js"
export * from "./TasksManager.vue?vue&type=script&lang=js"

import "./TasksManager.vue?vue&type=style&index=0&id=4946cbbc&lang=css"

import exportComponent from "/home/debian/plan.docks40.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__